'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["userPreferences"];
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UnassignedQueueCount from './UnassignedQueueCount';
import SupportLanguages from '../../constants/SupportLanguages';
import UserPreferences from '../../models/UserPreferences';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const userPreferencesPropDefault = new UserPreferences();
function UnassignedQueueSummary(_ref) {
  let {
      userPreferences = userPreferencesPropDefault
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const props = Object.assign({
    userPreferences
  }, rest);
  function renderNoPreferencesSet() {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "no-language-set-message",
        message: "app.card.queue.status.noPreferences"
      })
    });
  }
  return props.userPreferences.primaryLanguage ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UnassignedQueueCount, {
      "data-test-id": "queue-count-primary-lang",
      langQueueStatus: {
        queue: SupportLanguages[props.userPreferences.primaryLanguage],
        count: props.queueStatus[props.userPreferences.primaryLanguage]
      }
    }), props.userPreferences.secondaryLanguage ? /*#__PURE__*/_jsx(UnassignedQueueCount, {
      "data-test-id": "queue-count-secondary-lang",
      langQueueStatus: {
        queue: SupportLanguages[props.userPreferences.secondaryLanguage],
        count: props.queueStatus[props.userPreferences.secondaryLanguage]
      }
    }) : null]
  }) : renderNoPreferencesSet();
}
UnassignedQueueSummary.propTypes = {
  queueStatus: PropTypes.objectOf(PropTypes.number).isRequired,
  userPreferences: PropTypes.instanceOf(UserPreferences)
};
export default UnassignedQueueSummary;